import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const STORIES = [
  {
    quote: "I cleared my Thermodynamics backlog with 72 marks. He teaches cycles like stories, not formulas.",
    name: "Rohan Deshmukh", detail: "B.E. Mechanical · 2nd Year", result: "Backlog cleared",
  },
  {
    quote: "My daughter jumped from 68% to 91% in Class 10 CBSE Maths in a single year. Worth every rupee.",
    name: "Sunita Iyer", detail: "Parent · Class 10 CBSE", result: "68% → 91%",
  },
  {
    quote: "After Technical Analysis Mastery I had my first consistently profitable quarter. The risk rulebook alone is worth the fee.",
    name: "Arjun Mehta", detail: "Trading Student", result: "First green quarter",
  },
  {
    quote: "SFD and BMD used to terrify me. Now I solve them in minutes — SOM finally clicked.",
    name: "Priya Nair", detail: "Diploma Mechanical", result: "SOM mastered",
  },
  {
    quote: "He teaches my son's exact ICSE textbook, chapter by chapter. Class 8 Science went from fear to favourite subject.",
    name: "Farhan Sheikh", detail: "Parent · Class 8 ICSE", result: "ICSE · Class 8",
  },
  {
    quote: "The MBA Finance course made DCF valuation feel obvious. I cracked my campus placement interview with it.",
    name: "Kavya Reddy", detail: "MBA Finance Student", result: "Placed",
  },
];

export const Testimonials = () => (
  <section id="stories" className="border-t border-white/10 px-6 py-24 md:px-12 md:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-[1600px]">
      <p className="mb-4 text-xs font-medium uppercase tracking-[0.4em] text-brand">Success Stories</p>
      <div className="mb-16 flex flex-wrap items-end justify-between gap-6">
        <h2 className="font-display text-4xl font-black uppercase leading-none tracking-tighter sm:text-5xl lg:text-6xl">
          Results speak<span className="text-brand">.</span>
        </h2>
        <p className="max-w-sm text-sm leading-relaxed text-zinc-500">
          Backlogs cleared, board percentages jumped, first profitable quarters — this is what one-on-one calibre teaching does.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-2 lg:grid-cols-3">
        {STORIES.map((s, i) => (
          <motion.figure
            key={s.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: (i % 3) * 0.1, duration: 0.7, ease: EASE }}
            className="group flex flex-col justify-between bg-[#0a0a0a] p-8 transition-colors duration-300 hover:bg-[#111111] md:p-10"
            data-testid={`testimonial-${i}`}
          >
            <div>
              <Quote size={22} className="text-brand" />
              <blockquote className="mt-6 font-editorial text-lg italic leading-relaxed text-zinc-200 md:text-xl">
                "{s.quote}"
              </blockquote>
            </div>
            <figcaption className="mt-8 flex items-end justify-between gap-4 border-t border-white/10 pt-6">
              <div>
                <div className="font-display text-base font-bold tracking-tight">{s.name}</div>
                <div className="mt-1 text-xs uppercase tracking-widest text-zinc-600">{s.detail}</div>
              </div>
              <span className="shrink-0 bg-brand/10 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-brand">
                {s.result}
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
